import { render } from "./ContentDuplicate.vue?vue&type=template&id=5f7b030b"
import script from "./ContentDuplicate.vue?vue&type=script&lang=js"
export * from "./ContentDuplicate.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__